export default {
  history: 'Recent 7 days history',
  refreshTime: 'Last Refresh Time: ',
  status: 'Status',
  tunnelMachine: 'Tunnel Machine',
  updateTime: 'Last Update Time',
  success: 'Success',
  apiType: 'API Type',
  failCount: 'Fail Count',
  store: 'Store',
  StoreOrTunnel: 'Store/Tunnel',
  tunnelReportTitle: 'Tunnel Machine Status Report',
  tunnelMachineId: 'Tunnel Machine ID',
  statusCode: 'Status',
  description: 'Description',
  time: 'Time',
  timeDate: 'Date',
  apiReportTitle: 'API Status Report',
  api: 'API',
  apiStatus: 'Status',
  errorCode: 'Error Code',
  errorMessage: 'Error Message',
  messageId: 'Message ID',
  payload: 'Payload',
  plant: 'Plant'
}
